/* eslint-disable react/display-name */
import React, { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { reduxConnect } from '../../common';
import { translate } from  '../../common/translation/translate';
import { dataLayer } from '@weatherbug/common';
const { getVideos } = dataLayer.actions;

const mapStoreStateToProps = storeState => {
    const appState = storeState.appState.appState || {};
    const { videos, pageNumber, totalVideoCount } = storeState?.video;
    const { authId, secret, stdParameters, videoBaseUrl } = appState;

    return{
        videos,
        totalVideoCount,
        videoBaseUrl,
        authId,
        secret,
        stdParameters,
        pageNumber
    };
};

const mapDispatchToProps = { getVideos };

const pageSize = 50;
const verbose = false;

export const LoadMoreVideos = reduxConnect( mapStoreStateToProps, mapDispatchToProps ) (memo(({
    videos,
    totalVideoCount,
    videoBaseUrl,
    authId,
    secret,
    stdParameters,
    pageNumber,
    getVideos
}) => {
    const onLoadMoreVideosButtonClick = useCallback(() => {
        if (videoBaseUrl && authId && secret && stdParameters) {

            try {
                getVideos(videoBaseUrl, authId, secret, pageNumber + 1, pageSize, verbose, stdParameters);
            } catch (error) {
                console.log(error);
            }
        }
    }, [videoBaseUrl, authId, secret, stdParameters, pageNumber, getVideos]);

    if (totalVideoCount && totalVideoCount < videos?.length) {
        return null;
    }
    return(
        <LoadMoreButton
            onClick={onLoadMoreVideosButtonClick}>
            {translate('loadMore')}
        </LoadMoreButton>
    );
}));

LoadMoreVideos.displayName = 'LoadMoreVideos';
LoadMoreVideos.propTypes = {
    videos: PropTypes.array
};

const LoadMoreButton = styled.div`
    font-size: 18px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    cursor: pointer;
    line-height: 22px;
    height: 48px;
    width: 130px;
    padding: 10px 20px;
    margin: 20px auto 40px;
    color: rgba(255, 255, 255, .5);
    &:transition {
        color: '.15s ease-in-out';
    }
    &:hover {
        color: rgba(255, 255, 255, .8);
    }
`;
